/**
 * The homepage's Impact preview: the same two presentations as /impact,
 * pinned pages (case studies) as lines, then the three latest other pages as
 * swipeable cards.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loadPublishedImpact } from "../../core/content";
import { useLocales } from "../../core/i18n";
import { SectionTitle } from "../../ui/kit";
import { SweepWord } from "../../ui/motion";
import { CONTAINER, SECTION_PAD, TITLE_TO_CONTENT } from "../../ui/shell";
import { ImpactCards, ImpactLines } from "../impact";

/** Renders nothing until at least one Impact page is published (or when loading fails). */
const HomeImpact = () => {
	const { t } = useLocales();
	const [pages, setPages] = useState([]);
	useEffect(() => {
		loadPublishedImpact()
			.then(setPages)
			.catch(() => {});
	}, []);

	if (pages.length === 0) return null;
	const pinned = pages.filter((a) => a.pinned);
	const latest = pages.filter((a) => !a.pinned).slice(0, 3);
	return (
		<section className={`bg-pp-bg ${SECTION_PAD}`}>
			<div className={CONTAINER}>
				<SectionTitle description={t("homepage.impactDescription")}>
					{t("homepage.impactTitle")}
					<SweepWord dark={false}>{t("homepage.impactTitleHighlight")}</SweepWord>
				</SectionTitle>
				<div className={TITLE_TO_CONTENT}>
					{pinned.length > 0 && <ImpactLines pages={pinned} />}
					{latest.length > 0 && (
						<div className={pinned.length > 0 ? "mt-14" : ""}>
							<ImpactCards swipe pages={latest} />
						</div>
					)}
					<div className="mt-10">
						<Link to="/impact" className="pp-link">
							{t("impact.viewAll")}
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
};

export default HomeImpact;
